<template>
  <div>
    <TText
      variant="semibold"
      color="text-white"
      size="sm"
      classes="uppercase mb-2"
    >
      {{ t(MenuFooterSocialLinksInstance.title) }}
    </TText>

    <ul class="flex space-x-6 md:order-2">
      <li
        v-for="(item, index) in MenuFooterSocialLinksInstance.links"
        :key="index"
      >
        <a
          :href="item.href"
          class="text-gray-400 hover:text-white transition ease-in-out duration-300"
          :rel="item.rel"
          :target="item.target"
          :aria-label="item.name"
        >
          <UIcon
            :name="item.icon as string"
            class="h-6 w-6 text-current"
            aria-hidden="true"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useMenuFooterSocial } from '../composables/useMenuFooterSocial'
const { MenuFooterSocialLinksInstance } = await useMenuFooterSocial()
</script>
